import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getOrder } from '../../selectors/order/get-order';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
import { assertIsOrderCreated } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
export const loadCurrentOrderRedirectPayment = async (pollForCompletionStatus) => {
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot load current redirect payment');
    let response;
    const deregisterAction = registerOrderAction('load-current-order-redirect-payment');
    try {
        response = await ocapiClient.instance.v1.orders.payments.redirect.getCurrent(order.id, pollForCompletionStatus);
    }
    finally {
        deregisterAction();
    }
    runInAction(() => {
        temporaryOrderDomainStore.data.payments.currentRedirectPayment = response;
    });
    return response;
};
